// extracted by mini-css-extract-plugin
export default {"container":"copyrights_container__fQ4tj"};